module.exports = __webpack_public_path__ + "media/images/iconSocialLink__inactive-3a307118f1c851f229255647ba400d4d.png";